module.exports = __webpack_public_path__ + "img/Close2.57d871ce.svg";